module.exports = __webpack_public_path__ + "img/cancel.a294083f.svg";